import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ActionSheetContext from './ActionSheetContext';

const ActionSheet = ({ initialVisible, children }) => {
  const triggerRef = React.useRef();
  const [isVisible, setIsVisible] = React.useState(initialVisible);

  const actionSheetContextValues = useMemo(
    () => ({
      triggerRef,
      isVisible,
      setIsVisible,
    }),
    [triggerRef, isVisible, setIsVisible],
  );

  return (
    <ActionSheetContext.Provider value={actionSheetContextValues}>
      {children}
    </ActionSheetContext.Provider>
  );
};

ActionSheet.propTypes = {
  children: PropTypes.node,
  initialVisible: PropTypes.bool,
};

export default ActionSheet;
